/**
 * Timeout constants (in milliseconds)
 */

/** Default timeout for bridge command responses (30 seconds) */
export const DEFAULT_BRIDGE_TIMEOUT = 30_000;

/** Time to wait for widget READY event before forcing ready state (5 seconds) */
export const READY_CHECK_TIMEOUT = 5000;

/** Timeout for widget to become ready when opening (30 seconds) */
export const WIDGET_READY_TIMEOUT = 30_000;

/** Fallback timeout for OPENED event after OPEN command (2 seconds) */
export const OPEN_FALLBACK_TIMEOUT = 2000;

/**
 * Default bubble dimensions (in pixels)
 */

/** Default width of the bubble widget when expanded */
export const DEFAULT_BUBBLE_WIDTH = 400;

/** Default height of the bubble widget when expanded */
export const DEFAULT_BUBBLE_HEIGHT = 600;

/** Default border radius for the bubble widget */
export const DEFAULT_BUBBLE_BORDER_RADIUS = 12;

/** Default horizontal offset from screen edge */
export const DEFAULT_BUBBLE_OFFSET_X = 20;

/** Default vertical offset from screen edge */
export const DEFAULT_BUBBLE_OFFSET_Y = 20;

/** Size of the collapsed bubble indicator */
export const COLLAPSED_BUBBLE_SIZE = 60;

/**
 * Default box shadow
 */
export const DEFAULT_BOX_SHADOW = "0 4px 12px rgba(0, 0, 0, 0.15)";

/**
 * Default theme colors
 */

/** Default primary/accent color */
export const DEFAULT_PRIMARY_COLOR = "#007bff";

/** Default background color */
export const DEFAULT_BACKGROUND_COLOR = "#ffffff";

/** Default text color (used on primary color backgrounds) */
export const DEFAULT_TEXT_COLOR = "#ffffff";

/**
 * Z-index values
 */

/** Z-index for the bubble widget wrapper */
export const BUBBLE_Z_INDEX = 9999;
